module.exports = __webpack_public_path__ + "img/odovzdanie-bytov.0d095d57.svg";